module.exports = __webpack_public_path__ + "static/media/wechat_group_qr.b70b83ac.jpg";